import Vue from 'vue';
import Collection from '@/collection';

class BaseService {
  static findAll(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${this.resource}/`, { params })
        .then((response) => {
          if (this.model) {
            return resolve(new Collection(response.body, this.model));
          }
          return resolve(response.body);
        })
        .catch(err => reject(err));
    });
  }

  static findOne(id) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${this.resource}/${id}/`)
        .then(response => resolve(response.body))
        .catch(err => reject(err.body));
    });
  }

  static create(data) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${this.resource}/`, data)
        .then(response => resolve(response.body))
        .catch(err => reject(err.body));
    });
  }

  static update(slug, data) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${this.resource}/${slug}/`, data)
        .then(response => resolve(response.body))
        .catch(err => reject(err.body));
    });
  }

  static count(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${this.resource}/count/`, { params })
        .then(response => resolve(response.body))
        .catch(err => reject(err.body));
    });
  }

  static delete(id) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete(`${this.resource}/${id}/`)
        .then(response => resolve(response.body.count))
        .catch(err => reject(err.body));
    });
  }
}

Object.assign(BaseService, {
  resource: '',
});

export default BaseService;
